import {connect} from "react-redux";
import LeadDsmPendingList from "./PendingList";
import {bindActionCreators} from "redux";
import {pendingListRequest} from "../../../../service/Lead/action";

const mapStateToProps = (state) => ({
    pendingListResponse:state.Lead.pendingListResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            pendingListRequest,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(LeadDsmPendingList);
